import * as React from 'react';
import styled from 'styled-components';
import { media } from '../../Themes';

interface IProps extends React.HTMLAttributes<any> {
  left?: boolean;
  isOpen: boolean;
  children?: any;
  backgroundColor?: string;
  onToggleOpen: () => any;
}

const StyledDrawer = styled.div<IProps>`
  height: 100vh;   
  display: flex;
  width: ${props => props.isOpen ? '250px' : '0'};    

  ${media.tablet(`
    position: relative;
  `)}

  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);

  position: absolute;  
  top: 0; 
  right: 0;

  
  flex-direction: column;
  flex: 0 0 auto;
  
  overflow-x: hidden;  
  transition: 0.2s;

  z-index: 100;

  background-color: ${props => props.backgroundColor ? props.theme[props.backgroundColor] : '#FFF'};
`;

const Overlay = styled.div<{ isOpen: boolean }>`
  ${media.desktop('display: none;')}

  display: block;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.6);
  z-index: 99;
  cursor: pointer;
`;

const PermanentDrawer = ({ ...props }: IProps) => {

  const toggleOpen = () => props.onToggleOpen();

  const overlayShow =
    props.isOpen
      ? <Overlay onClick={toggleOpen} isOpen={props.isOpen} />
      : null;

  return (
    <>
      {overlayShow}
      <StyledDrawer {...props}>
        {props.children}
      </StyledDrawer>
    </>
  );
};

export default PermanentDrawer;